import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import VideoModalOne from '../../components/video-modal-one'
import Partner from '../../components/partner'
import PricingOne from '../../components/pricing-one'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/software/software.jpg'
import homeImg from '../../assets/images/software/home.png'
import software from '../../assets/images/software/01.jpg'
import software2 from '../../assets/images/software/02.jpg'

import { feature } from '../../data/sooftware'

export default function IndexSoftware() {
  return (
    <>
      <Navbar navLight={true}/>

      <section className="bg-home d-flex align-items-center" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center', height:'auto'}} id="home">
          <div className="container">
              <div className="row justify-content-center">
                  <div className="col-12 text-center mt-0 mt-md-5 pt-0 pt-md-5">
                      <div className="title-heading margin-top-100">
                          <h1 className="heading text-white title-dark mb-3">The First Software Development Tool.</h1>
                          <p className="para-desc mx-auto para-dark text-light">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                          <div className="watch-video mt-4 pt-2">
                              <VideoModalOne textLight={true}/>
                          </div>
                      </div>

                      <div className="home-dashboard">
                          <img src={homeImg} alt="" className="img-fluid"/>
                      </div> 
                  </div>
              </div>
          </div> 
      </section>

      <section className="section-two bg-light">
        <div className="container">
            <Partner/>
        </div>
      </section>

      <section className="section">
        <div className="container">
            <div className="row">
              {feature.map((item,index)=>{
                let Icon = item.icon
                return(
                  <div className="col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0" key={index}>
                      <div className="feature p-3 py-5 rounded text-center">
                          <i className="h1 text-primary"><Icon/></i>
                          <div className="content">
                              <h4 className="title mt-3">{item.title}</h4>
                              <p className="text-muted mt-2 mb-0">{item.desc}</p>
                          </div>
                      </div>
                  </div>
                )
              })}
            </div>
        </div>

        <div className="container mt-100 mt-60">
            <div className="row align-items-center">
                <div className="col-lg-5 col-md-6">
                    <img src={software} className="img-fluid rounded shadow" alt=""/>
                </div>

                <div className="col-lg-7 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="section-title">
                        
                        <h4 className="title mt-3 mb-4">Build beautiful & modular software</h4>
                        <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                        <ul className="list-inline mb-0">
                            <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I upgrade later on?</li>
                            <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I port my data from another provider?</li>
                            <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Are my food photos stored forever in the cloud?</li>
                            <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Who foots the bill for that?</li>
                        </ul>
                        <div className="mt-4">
                            <Link to="#" className="text-primary">Learn More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="container mt-100 mt-60">
            <div className="bg-light rounded p-md-5 p-4 p-sm-0 shadow">
                <div className="row align-items-center">
                    <div className="col-sm-7">
                        <div className="text-sm-start">
                            <h4>Start building beautiful block-based websites.</h4>
                            <p className="text-muted para-desc mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                        </div>
                    </div>

                    <div className="col-sm-5 mt-4 mt-sm-0">
                        <div className="text-sm-end">
                            <Link to="#" className="btn btn-outline-primary"><i className="mdi mdi-bookmark"></i> Explore Now</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="container mt-100 mt-60">
            <div className="row align-items-center">
                <div className="col-lg-5 col-md-6 order-1 order-md-2 text-end">
                    <img src={software2} className="img-fluid rounded shadow" alt=""/>
                </div>

                <div className="col-lg-7 col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="section-title">
                        <span className="badge bg-danger"> Hot </span>
                        <h4 className="title mt-3 mb-4">Less working, More sales flow.</h4>
                        <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                        <ul className="list-inline mb-0">
                            <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I upgrade later on?</li>
                            <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I port my data from another provider?</li>
                            <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Are my food photos stored forever in the cloud?</li>
                            <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Who foots the bill for that?</li>
                        </ul>
                        <div className="mt-4">
                            <Link to="#" className="text-primary">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        

        
        <div className="container mt-100 mt-60">
            <div className="row">
                <div className="col-12 text-center">
                    <div className="section-title mb-4 pb-2">
                        <h4 className="title mb-4">Our Pricing</h4>
                        <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                    </div>
                </div>
            </div>

            <PricingOne/>
        </div>
        

        
        <div className="container mt-100 mt-60">
            <div className="row justify-content-center">
                <div className="col-12 text-center">
                    <div className="section-title mb-4 pb-2">
                        <span className="badge bg-primary rounded-pill"> Subscribe </span>
                        <h4 className="title mt-3 mb-4">Sign up for our Newsletter</h4>
                        <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                    </div>
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-lg-9 mt-4 pt-2">
                    <form>
                        <div className="row justify-content-center align-items-center">
                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label className="form-label">First Name <span className="text-danger">*</span></label>
                                    <input name="name" id="fname" type="text" className="form-control" placeholder="First Name :"/>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label className="form-label">Last Name <span className="text-danger">*</span></label>
                                    <input name="name" id="lname" type="text" className="form-control" placeholder="Last Name :"/>
                                </div> 
                            </div>
                            <div className="col-md-4">
                                <div className="mb-3">
                                    <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                    <input name="email" id="email" type="email" className="form-control" placeholder="Your email :"/>
                                </div> 
                            </div>
                            <div className="col-md-4">
                                <div className="d-grid">
                                    <button id="subscribe" type="submit" className="btn btn-primary mb-2">Subscribe</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
      </section>
      <Footer/>
    </>
  )
}
